import React, { useEffect } from "react";
import TechnicianService from "../services/technician.service";

type ConflictObserverProps = {
  startDateTime: Date | string | null | undefined;
  durationHours?: number;
  endDateTime?: Date | string | null | undefined;
  technicianId?: string | null;
  type: "service" | "dyno";
  setConflictWarning: (warning: string | null) => void;
};

const ConflictObserver = ({
  startDateTime,
  durationHours,
  endDateTime,
  technicianId = null,
  type,
  setConflictWarning,
}: ConflictObserverProps) => {
  useEffect(() => {
    if (!startDateTime) {
      setConflictWarning(null);
      return;
    }

    const start = new Date(startDateTime);
    start.setSeconds(0, 0);

    let end: Date;
    if (endDateTime) {
      end = new Date(endDateTime);
    } else if (durationHours) {
      end = new Date(start.getTime() + durationHours * 60 * 60 * 1000);
    } else {
      setConflictWarning(null);
      return;
    }
    end.setSeconds(0, 0);

    TechnicianService.checkConflict({
      start_date_time: start.toISOString(),
      end_date_time: end.toISOString(),
      technician_id: technicianId,
      type,
    })
      .then((res) => {
        if (res.data?.data?.hasConflict) {
          setConflictWarning(res.data.data.message);
        } else {
          setConflictWarning(null);
        }
      })
      .catch(() => {
        setConflictWarning(null);
      });
  }, [startDateTime, durationHours, endDateTime, technicianId, type, setConflictWarning]);

  return null;
};

export default ConflictObserver;
